export default function makeCancelable(promise) {
  let hasCanceled = false;

  const wrappedPromise = new Promise((resolve, reject) => {
    promise
      .then(value => !hasCanceled && resolve(value))
      .catch(error => !hasCanceled && reject(error));
  });

  wrappedPromise.cancel = () => {
    hasCanceled = true;
  };

  return wrappedPromise;
}
